<template>
  <div
    class="player"
    :style="{ width: width, '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <div
      class="img-box"
      :class="playerImg ? 'isLogo' : ''"
      :style="{ width: playerLogoSize[0], height: playerLogoSize[1] }"
    >
      <img v-if="playerImg" :src="playerImg" alt="" />
    </div>
    <div class="name-box">
      <span
        v-if="!!playerNum"
        v-text="
          `${playerNum + '' ? '#' : ''}${_valPerFormatHandler(playerNum)} `
        "
      ></span>
      <span v-text="_valPerFormatHandler(playerName)"></span>
      <span v-if="!!playerEn" v-text="`(${playerEn})`"></span>
      <div class="player_info_box" v-if="age || clubName || height">
        <div class="player_info">
          <div>{{ age }}岁</div>
          <div>{{ height }}CM</div>
        </div>
        <div class="club_name">{{ clubName }}</div>
      </div>
    </div>
    <div class="country-box">
      <span
        class="country_logo"
        :style="{ width: countryLogoSize[0], height: countryLogoSize[1] }"
      >
        <img v-if="countryImg" :src="countryImg" alt="" />
      </span>
      <span
        class="country-name"
        v-text="_valPerFormatHandler(countryName)"
      ></span>
    </div>
  </div>
</template>

<script>
// 球员信息
export default {
  props: {
    // 必传参数，球员图片
    playerImg: {
      type: String,
      default: '',
    },
    // 必传参数，球员号码
    playerNum: {
      default: '',
    },
    // 必传参数，球员姓名
    playerName: {
      type: String,
      default: '',
    },
    // 必传参数，国家图片
    countryImg: {
      type: String,
      // default: 'https://mms-voice.cdn.bcebos.com/ressync/voiceability/taste/voice_matcher_day.png'
    },
    // 必传参数，国家中文名
    countryName: {
      type: String,
      default: '',
    },
    // 必传参数，球员名字后面的英文字母
    playerEn: {
      type: String,
    },
    width: {
      type: String,
      default: 'calc(7.64vw * var(--mixtmt_mixvw))', //'7.64vw',
    },
    countryLogoSize: {
      type: Array,
      default: () => {
        return [
          'calc(2.498vw * var(--mixtmt_mixvw))',
          'calc(1.666vw * var(--mixtmt_mixvw))',
        ] //['2.498vw', '1.666vw']
      },
    },
    playerLogoSize: {
      type: Array,
      default: () => {
        return [
          'calc(6.25vw * var(--mixtmt_mixvw))',
          'calc(8.33vw * var(--mixtmt_mixvw))',
        ] //['2.498vw', '1.666vw']
      },
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    age: {
      type: Number,
      default: 0,
    },
    clubName: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {}
  },
  methods: {
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.player {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: calc(7.64vw * var(--mixtmt_mixvw));
  .img-box {
    position: relative;
    width: calc(6.25vw * var(--mixtmt_mixvw));
    height: calc(8.33vw * var(--mixtmt_mixvw));
    background-size: 100% auto;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-image: var(--mixtmt_default_playerLogo);
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 1px solid var(--mixtmt_greyColor5);
    }
    &.isLogo {
      background-image: none;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .name-box {
    margin: calc(0.556vw * var(--mixtmt_mixvw)) 0
      calc(0.833vw * var(--mixtmt_mixvw)) 0;
    font-size: calc(0.972vw * var(--mixtmt_mixvw));
    color: var(--mixtmt_greyColor_main);
    line-height: calc(1.25vw * var(--mixtmt_mixvw));
    text-align: center;
    max-width: 100%;
    .player_info {
      display: flex;
      margin-top: calc(0.278vw * var(--mixtmt_mixvw));
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: calc(0.694vw * var(--mixtmt_mixvw));
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      & > div:not(:last-child) {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        &::after {
        content: '';
          display: block;
          width: calc(0.12vw * var(--mixtmt_mixvw));
          height: calc(0.972vw * var(--mixtmt_mixvw));
          background-color: var(--mixtmt_greyColor_main);
          margin-left: calc(0.694vw * var(--mixtmt_mixvw));
        }
      }
      & > div:last-child {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .club_name {
      margin-top: calc(0.278vw * var(--mixtmt_mixvw));
    }
  }
  .country-box {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .country_logo {
      position: relative;
      /* width: 2.498vw;
      height: 1.666vw; */
      /* margin-right: 0.694vw; */
      overflow: hidden;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_greyColor5);
      }
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .country-name {
      flex: 1;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor_main);
      line-height: calc(1.666vw * var(--mixtmt_mixvw));
      vertical-align: top;
      text-align: center;
      padding-left: calc(0.694vw * var(--mixtmt_mixvw));
    }
  }
}
</style>
